import React from 'react';
import classnames from 'classnames';
import DocViewerFieldSignature from './Field/Signature';
import OrderDoc from '~/model/orderDoc';

const DocViewerSignedField = (props: { field: any }) => {

  /**
   * Component props:
   * field {object} the signature field
   */
  const { field } = props;

  /**
   * Fields themselves do not carry an orientation property
   * So we need to read and attach that again from the field config
   */
  field.orientation = OrderDoc.getFieldOrientation(field.type);

  /**
   * The style of the field, mainly establishing position and size
   * We want to use percentage position/size so it works with every zoom level
   */
  const fieldStyle: any = {
    position: 'absolute',
    top: `${field.topPc}%`,
    left: `${field.leftPc}%`,
    width: `${field.widthPc}%`,
    height: `${field.heightPc}%`,
  };

  /**
   * Field css classed
   */
  const cssClass = classnames(
    'doc-viewer-field',
    'doc-viewer-field-signed',
    'user-select-none',
    'pe-none'
  );

  return <React.Fragment>
    <div className={cssClass} style={fieldStyle}>
      <div className="doc-viewer-field-body">
        <div className="doc-viewer-field-content">
          <DocViewerFieldSignature field={field} />
        </div>
      </div>
    </div>
  </React.Fragment>
};

export default DocViewerSignedField;